(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["custom-cart-drawer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('custom-cart-quantity')) {
    /*
     * Shared queue for quantity changes in the cart drawer.
     * - Clicks only change the number locally and mark the line as pending.
     * - After 400ms without clicks, one /cart/update.js request sends the final
     *   quantity of every pending line.
     * - Requests run one at a time, so the store always receives them in order.
     * - A response is only rendered when no newer click happened since it was sent;
     *   otherwise the next request (with the newer quantities) goes out instead.
     */
    const CustomCartQuantityQueue = {
      pending: new Map(),
      timer: null,
      inFlight: false,
      latestChange: 0,
      focus: null,

      schedule(lineKey, quantity, focus) {
        this.latestChange += 1;
        this.pending.set(lineKey, quantity);
        this.focus = focus;
        document.getElementById('CartDrawer')?.classList.add('is-updating');
        clearTimeout(this.timer);
        this.timer = setTimeout(() => this.flush(), 400);
      },

      flush() {
        if (this.inFlight || this.pending.size === 0) return;

        const updates = Object.fromEntries(this.pending);
        this.pending.clear();
        const changeAtSend = this.latestChange;
        this.inFlight = true;

        fetch(window.routes.cart_update_url + '.js', {
          ...fetchConfig(),
          body: JSON.stringify({
            updates,
            sections: ['cart-drawer', 'cart-icon-bubble'],
            sections_url: window.location.pathname,
          }),
        })
          .then((response) => response.json().then((state) => ({ ok: response.ok, state })))
          .then(({ ok, state }) => {
            if (changeAtSend !== this.latestChange) return;
            if (!ok || state.status || !state.sections) {
              this.showError(state.description || state.message);
              return this.refresh();
            }
            this.render(state.sections);
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: state });
          })
          .catch(() => {
            if (changeAtSend === this.latestChange) return this.refresh();
          })
          .finally(() => {
            this.inFlight = false;
            // Clicks that came in while this request was on its way go out now
            if (this.pending.size > 0) this.flush();
          });
      },

      refresh() {
        return fetch(window.routes.cart_url + '?sections=cart-drawer,cart-icon-bubble')
          .then((response) => response.json())
          .then((sections) => {
            if (this.pending.size === 0) this.render(sections);
          });
      },

      render(sections) {
        const parse = (html, selector) => new DOMParser().parseFromString(html, 'text/html').querySelector(selector);

        const newInner = parse(sections['cart-drawer'], '.drawer__inner');
        const inner = document.querySelector('#CartDrawer .drawer__inner');
        if (newInner && inner) inner.innerHTML = newInner.innerHTML;

        const newBubble = parse(sections['cart-icon-bubble'], '.shopify-section');
        const bubble = document.getElementById('cart-icon-bubble');
        if (newBubble && bubble) bubble.innerHTML = newBubble.innerHTML;

        document.querySelector('cart-drawer')?.classList.toggle('is-empty', !document.querySelector('#CartDrawer .cart-item'));
        document.getElementById('CartDrawer')?.classList.remove('is-updating');

        if (this.focus) {
          document.querySelector('#CartDrawer-Item-' + this.focus.line + ' [name="' + this.focus.name + '"]')?.focus();
        }
      },

      showError(message) {
        const errors = document.getElementById('CartDrawer-CartErrors');
        if (errors && message) errors.textContent = message;
      },
    };

    class CustomCartQuantity extends HTMLElement {
      connectedCallback() {
        this.input = this.querySelector('input');
        if (!this.input) return;

        this.querySelectorAll('button[name]').forEach((button) => {
          button.addEventListener('click', (event) => {
            event.preventDefault();
            this.step(button.name === 'plus' ? 1 : -1, button.name);
          });
        });

        // Typed quantities use the same queue; stop the event so Dawn's cart-items handler doesn't run as well
        this.input.addEventListener('change', (event) => {
          event.stopPropagation();
          this.setQuantity(parseInt(this.input.value, 10), null);
        });
      }

      step(direction, buttonName) {
        const step = parseInt(this.input.step, 10) || 1;
        const current = parseInt(this.input.value, 10) || this.min;
        this.setQuantity(current + direction * step, buttonName);
      }

      setQuantity(value, buttonName) {
        const max = this.input.max ? parseInt(this.input.max, 10) : Infinity;
        const quantity = Math.min(Math.max(Number.isNaN(value) ? this.min : value, this.min), max);
        this.input.value = quantity;
        this.closest('.cart-item')?.classList.add('is-updating');
        CustomCartQuantityQueue.schedule(this.input.dataset.quantityLineKey, quantity, {
          line: this.input.dataset.index,
          name: buttonName || 'updates[]',
        });
      }

      get min() {
        return Math.max(1, parseInt(this.input.min, 10) || 1);
      }
    }

    customElements.define('custom-cart-quantity', CustomCartQuantity);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["custom-size-guide"] && !Shopify.designMode) return;
  try {
    if (!window.customDialogsReady) {
    window.customDialogsReady = true;

    document.addEventListener('click', (event) => {
      const opener = event.target.closest('[data-custom-dialog-open]');
      if (opener) {
        const dialog = document.getElementById(opener.dataset.customDialogOpen);
        if (dialog && !dialog.open) dialog.showModal();
        return;
      }

      const closer = event.target.closest('[data-custom-dialog-close]');
      if (closer) {
        closer.closest('dialog')?.close();
        return;
      }

      // A click on the dialog element itself is a click on the overlay around the panel
      if (event.target instanceof HTMLDialogElement && event.target.classList.contains('custom-size-guide')) {
        event.target.close();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
